import axios from "axios";
import { OOT_CONFIGURATOR } from "Components/Misc/CaseDetails_System";
import { store } from "Store/mainStore";

class ConfiguratorServices {
    getState() {
        // Import your Redux store and selector
        const reduxtStore = store.getState();
        // Placeholder for demonstration:
        const email = reduxtStore.authSlice?.login?.mail || ""; // Replace with actual Redux state value
        return { email };
    }
    // get segment solution list on select of segments
    getSegmentList = async (solutionType=undefined) => {
        const { email } = this.getState();
        const params = `?_format=json&username=${email}${solutionType ? `&solutionType=${solutionType}` : ''}`;
        const res = await axios({
            method: "get",
            // url: process.env.REACT_APP_CONFIGURATOR + '/segment/list' + params,
            url: OOT_CONFIGURATOR.baseUrl + OOT_CONFIGURATOR.endPoints.configurator + '/segment/list' + params,
        });
        return res.data;
    };
}

const CONFIGURATOR_SERVICES = new ConfiguratorServices();
export default CONFIGURATOR_SERVICES;